import { render, staticRenderFns } from "./UserRestrictionInfo.vue?vue&type=template&id=55dbd54a&scoped=true&lang=pug&"
import script from "./UserRestrictionInfo.vue?vue&type=script&lang=js&"
export * from "./UserRestrictionInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserRestrictionInfo.vue?vue&type=style&index=0&id=55dbd54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dbd54a",
  null
  
)

export default component.exports